import { toCanonicalDateFromPtBr } from "@/utils/date";

export const featuredProducts: Array<{
  id: number;
  name: string;
  slug: string;
  category: string;
  categorySlug: string;
  image: string;
  price: number;
  originalPrice: number;
  discount: number;
  rating: number;
  reviews: number;
  marketplace: string;
  affiliateLink: string;
  badge: string | null;
  freeShipping: boolean;
}> = [];

export const categories = [
  {
    id: 1,
    name: "Eletrônicos",
    slug: "eletronicos",
    icon: "ri-tv-2-line",
    count: 1247,
    image: "https://readdy.ai/api/search-image?query=electronics%20gadgets%20smartphones%20laptops%20headphones%20clean%20minimal%20product%20arrangement%20modern%20technology%20background&width=600&height=400&seq=cat1&orientation=landscape",
    subcategories: ["Smartphones", "Notebooks", "Tablets", "Câmeras", "Fones de Ouvido"],
  },
  {
    id: 2,
    name: "Casa & Cozinha",
    slug: "casa-cozinha",
    icon: "ri-home-4-line",
    count: 892,
    image: "https://readdy.ai/api/search-image?query=home%20kitchen%20appliances%20modern%20clean%20minimal%20interior%20objects%20arrangement%20bright%20background&width=600&height=400&seq=cat2&orientation=landscape",
    subcategories: ["Eletrodomésticos", "Utensílios", "Móveis", "Decoração", "Organização"],
  },
  {
    id: 3,
    name: "Beleza",
    slug: "beleza",
    icon: "ri-heart-3-line",
    count: 534,
    image: "https://readdy.ai/api/search-image?query=beauty%20cosmetics%20skincare%20makeup%20products%20clean%20elegant%20arrangement%20soft%20lighting%20minimal%20background&width=600&height=400&seq=cat3&orientation=landscape",
    subcategories: ["Maquiagem", "Skincare", "Perfumes", "Cabelos", "Cuidados Pessoais"],
  },
  {
    id: 4,
    name: "Games",
    slug: "games",
    icon: "ri-gamepad-line",
    count: 423,
    image: "https://readdy.ai/api/search-image?query=gaming%20consoles%20controllers%20RGB%20lights%20modern%20clean%20arrangement%20dark%20background%20tech&width=600&height=400&seq=cat4&orientation=landscape",
    subcategories: ["Consoles", "Jogos", "Acessórios", "PC Gamer", "Cadeiras Gamer"],
  },
  {
    id: 5,
    name: "Moda",
    slug: "moda",
    icon: "ri-t-shirt-line",
    count: 2891,
    image: "https://readdy.ai/api/search-image?query=fashion%20clothing%20accessories%20shoes%20bags%20modern%20style%20flat%20lay%20clean%20background%20trendy&width=600&height=400&seq=cat5&orientation=landscape",
    subcategories: ["Roupas Masculinas", "Roupas Femininas", "Calçados", "Bolsas", "Relógios"],
  },
  {
    id: 6,
    name: "Esportes",
    slug: "esportes",
    icon: "ri-run-line",
    count: 678,
    image: "https://readdy.ai/api/search-image?query=sports%20equipment%20fitness%20gym%20weights%20running%20shoes%20bicycle%20outdoor%20adventure%20clean%20background&width=600&height=400&seq=cat6&orientation=landscape",
    subcategories: ["Fitness", "Bicicletas", "Camping", "Natação", "Futebol"],
  },
];

export const seoArticles = [
  {
    id: 1,
    title: "Qual a Melhor TV 50 Polegadas de 2024? Testamos 12 Modelos",
    slug: "melhor-tv-50-polegadas-2024",
    excerpt: "Comparamos as principais TVs 50 polegadas do mercado em resolução, qualidade de imagem, smart TV e custo-benefício. Veja qual vale a pena comprar.",
    category: "Televisores",
    categorySlug: "televisores",
    image: "https://readdy.ai/api/search-image?query=multiple%2050%20inch%204K%20TVs%20comparison%20review%20editorial%20photography%20modern%20living%20room%20setup&width=800&height=450&seq=art1&orientation=landscape",
    readTime: "12 min",
    date: "08 Abr 2024",
    views: 48291,
    featured: true,
  },
  {
    id: 2,
    title: "Melhor Notebook Custo-Benefício 2024: Top 10 Opções",
    slug: "melhor-notebook-custo-beneficio-2024",
    excerpt: "Encontre o notebook ideal para trabalho, estudo ou jogos sem gastar muito. Análise completa com prós, contras e onde comprar mais barato.",
    category: "Notebooks",
    categorySlug: "notebooks",
    image: "https://readdy.ai/api/search-image?query=laptop%20notebooks%20comparison%20review%20editorial%20photography%20desk%20workspace%20multiple%20models&width=400&height=280&seq=art2&orientation=landscape",
    readTime: "15 min",
    date: "07 Abr 2024",
    views: 32104,
    featured: false,
  },
  {
    id: 3,
    title: "iPhone 15 Vale a Pena? Review Completo Após 3 Meses de Uso",
    slug: "iphone-15-vale-a-pena-review",
    excerpt: "Usamos o iPhone 15 por 3 meses e testamos câmera, bateria, desempenho e comparamos com a concorrência. Veja se vale o investimento.",
    category: "Smartphones",
    categorySlug: "smartphones",
    image: "https://readdy.ai/api/search-image?query=iPhone%2015%20review%20editorial%20photography%20hands%20holding%20smartphone%20camera%20test%20outdoor%20lifestyle&width=400&height=280&seq=art3&orientation=landscape",
    readTime: "10 min",
    date: "06 Abr 2024",
    views: 27893,
    featured: false,
  },
  {
    id: 4,
    title: "Melhor Air Fryer 2024: Qual Comprar? Comparativo Completo",
    slug: "melhor-air-fryer-2024",
    excerpt: "Testamos as principais air fryers do mercado e elegemos as melhores por categoria: capacidade, preço, facilidade de uso e qualidade do resultado.",
    category: "Eletrodomésticos",
    categorySlug: "eletrodomesticos",
    image: "https://readdy.ai/api/search-image?query=air%20fryer%20comparison%20review%20editorial%20photography%20kitchen%20appliances%20multiple%20models%20food%20cooking&width=400&height=280&seq=art4&orientation=landscape",
    readTime: "8 min",
    date: "05 Abr 2024",
    views: 19432,
    featured: false,
  },
].map((article) => ({
  ...article,
  date: toCanonicalDateFromPtBr(article.date),
}));

export const productDetail = null;
